<template>
  <div style="width: 100%">
    <!-- 메인 컨텐츠 -->
    <v-card id="container" outlined rounded="md" width="100%" v-if="orgnSuccess && this.riskHr.length > 0" class="orgn-view-card">
      <div class="orgn-view-toolbar ml-5 mt-4 d-flex align-center">
        <v-btn color="primary" elevation="0" large outlined @click="orgRefresh()" class="mr-2 rounded">신규 조직도 불러오기</v-btn>
        <span>
          {{ `차수: ${orgnOrder}` }}
        </span>
      </div>
      <DxDiagram
        id="diagram"
        ref="dxDiagram"
        class="layout-col-height02"
        custom-shape-template="CustomShapeTemplate"
        :auto-zoom-mode="'disabled'"
        :simple-view="true"
        :read-only="true"
        :showGrid="false"
        style="width: 100%"
      >
        <!-- <DxZoomLevel :value="0.75" :items="['0.5', '0.75', '1', '1.5']" /> -->
        <DxViewToolbar :visible="false" />
        <DxCustomShape
          :ref="'employee' + employee.esgHrNo"
          v-for="employee in getRiskHumanResources"
          :category="employee.grpAuthCd"
          :type="'employee' + employee.esgHrNo"
          :base-type="'rectangle'"
          :title="'New Employee'"
          :default-width="1.8"
          :default-height="1"
          :toolbox-width-to-height-ratio="2"
          :default-text="getCustomShapeDefaultText(employee)"
          :allow-edit-text="false"
          :key="employee.esgHrNo"
          :min-width="1.8"
          :min-height="1"
          :max-width="1.8"
          :max-height="1"
        />
        <template #CustomShapeTemplate="{ data }">
          <CustomShapeTemplate v-if="data.dataItem && riskHr" :employee="data.dataItem" :riskHr="riskHr" />
        </template>
        <DxNodes
          :data-source="getRiskDetailDatasource"
          :key-expr="'id'"
          :type-expr="'type'"
          :custom-data-expr="itemCustomDataExpr"
          :text-style-expr="textStyleExpr"
          :parent-key-expr="'headId'"
          :css-class="'tooptip'"
        >
          <DxAutoLayout :type="'tree'" />
        </DxNodes>
      </DxDiagram>
    </v-card>
  </div>
</template>

<script>
import ArrayStore from 'devextreme/data/array_store'
import BaseDiagram from '@/views/base/BaseDiagram.vue'
import baseview from '@/views/base/baseview.vue'
import CustomShapeTemplate from '@/components/organization/CustomShapeTemplate.vue'
//function
import {
  getHumanResourceByRiskAsse,
  getRiskOrgnManageDetail, //위험성평가 조직 디테일
  getRiskOrgnManageMaster, //위험성평가 조직 마스터
} from '@/api/riskAssessment/riskOrgnManage'
export default {
  mixins: [baseview, BaseDiagram],
  name: 'OrganizationView',
  components: { CustomShapeTemplate },
  props: {
    orgnOrder: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      orgnSuccess: false,
      dxDiagramRef: 'dxDiagram',
      detailDatasource: [],
      dataSource: new ArrayStore({
        key: 'id',
        data: [],
      }),
      riskHr: [
        // { esgHrNo: '2', korNm: '임윤주', jbrp: 'B12', jbrpNm: '차장', riskAssRole: 'B10', riskAssRoleNm: '위험성평가 담당자' },
      ],
    }
  },
  watch: {},
  computed: {
    getRiskHumanResources() {
      return this.riskHr //.filter(x => x.hrDelYn != 'Y')
    },
    getRiskDetailDatasource() {
      this.dataSource = new ArrayStore({
        key: 'id',
        data: this.detailDatasource, //service.getEmployees(),
        onInserting(values) {
          values.esgHrNo = values.type.replace('employee', '')
          values.id = values.id
        },
      })
      return this.dataSource
    },
  },
  created() {},

  beforeMount() {
    //console.log('beforeMount')
    this.diagramRfs = [this.dxDiagramRef]
    //커스텀 Shape를 위한 역할 그룹 조회
  },
  mounted() {
    this.btnSearch()
    //컴포넌트를 위한 조직 버전 리스트 조회
    // this.btnSearch()
  },
  activated() {
    console.log('############### activated')
  },
  updated() {},
  methods: {
    //조직 구성도 조회
    async searchDetailData() {
      this.detailDatasource = []
      let params = {
        clntId: this.getClntId(),
        compId: this.getCompId(),
        orgnOrder: this.orgnOrder,
      }
      // this.openLoading()
      await getRiskOrgnManageDetail(params, false)
        .then((res) => {
          if (res.success) {
            this.detailDatasource = res.list
            // this.getExportToImage()
          }
        })
        .catch((error) => {
          console.error(error)
          // this.endLoading()
        })
        .finally(() => {
          this.orgnSuccess = true
          // this.endLoading()
        })
    },
    getExportToImage(type) {
      return new Promise((resolve, reject) => {
        this.Diagrams[0].exportTo('png', (result) => {
          if (result) {
            resolve(result)
          }
        })
      })
    },
    orgRefresh() {
      this.$emit('orgRefresh')
    },
    //------------------------------------------
    //조직 차수 리스트 조회(콤보박스)
    async btnSearch(bUse, orgnOrder) {
      this.orgnSuccess = false
      this.riskHr = []
      if (bUse == undefined) bUse = true
      let params = {
        clntId: this.getClntId(),
        compId: this.getCompId(),
        // orgnOrder: this.orgnOrder,
      }
      // this.openLoading()
      await getRiskOrgnManageMaster(params, false)
        .then((res) => {
          if (res.success) {
            //휴먼 리소스 조회하여 툴박수 구성
            if (bUse) {
              console.log('getHumanResourceByRiskAsse start')
              getHumanResourceByRiskAsse(params, false)
                .then((res) => {
                  if (res.success) {
                    this.riskHr = res.list || []
                    this.searchDetailData()
                  }
                })
                .catch((error) => {
                  // this.endLoading()
                })
                .finally(() => {
                  // this.endLoading()
                })
            }
          }
        })
        .catch((error) => {
          // this.endLoading()
        })
        .finally(() => {
          // this.endLoading()
        })
      return this.orgnSuccess
    },
    //------------------------------------------

    ///////////////////////////////////////
    /*        ETC Event Event       */
    ///////////////////////////////////////
    itemCustomDataExpr(obj, value) {
      if (value === undefined) {
        return {
          korNm: obj.korNm,
          orgnOrder: obj.orgnOrder,
          clntId: obj.clntId,
          grpAuthNm: obj.grpAuthNm,
        }
      }
      // obj.korNm = value.korNm
      obj.orgnOrder = value.orgnOrder
      obj.clntId = value.clntId
      obj.esgHrNo = value.esgHrNo
      obj.headId = value.headId
      obj.id = value.id

      return obj
    },
    textStyleExpr(obj) {
      return 'visibility:hidden'
    },
    getCustomShapeDefaultText(employee) {
      let defaultText = ''
      let exist = ''

      if (employee.sabun == undefined || employee.sabun == null || employee.sabun == '') {
        defaultText = employee.korNm
      } else {
        defaultText = employee.korNm + '(' + employee.sabun + ')'
      }

      if (employee.hrDelYn == 'Y') {
        exist = '(없음)'
      }

      return defaultText + exist //ex:이름(사번)(없음)
    },
  },
}
</script>
<style lang="scss" scoped>
.orgn-view-card {
  position: relative;
  // 내부 absolute/z-index가 fixed 진행률 패널보다 위로 튀지 않도록 스택킹 컨텍스트 격리
  z-index: 0;
  isolation: isolate;
}

.orgn-view-toolbar {
  position: absolute;
  z-index: 1;
}

@media screen and (max-width: 1280px) {
  .dx-diagram {
    width: 100% !important;
    height: auto !important;
  }
}
::v-deep .menuable__content__active {
  z-index: 1600 !important;
}
//
// #diagram {
//   height: 725px;
// }

.dx-popup-content {
  padding: 0;
}

.dx-popup-content .dx-fieldset.buttons {
  display: flex;
  justify-content: flex-end;
}

.dx-popup-content .dx-fieldset.buttons > * {
  margin-left: 8px;
}

::v-deep .menuable__content__active {
  z-index: 2000 !important ;
}

// ::v-deep .dx-accordion-item-opened > .dx-accordion-item-body {
//   display: none !important;
// }

::v-deep #diagram > .dx-diagram-floating-toolbar-container {
  left: 700px !important;
}

.displayNone {
  .dx-accordion-item-opened > .dx-accordion-item-body {
    display: none !important;
  }
}
</style>
